import { get } from '@/utils/client';

//types
import type { UploadedMediaType } from '@/utils/uploadMedia/uploadHelpers/types/UploadedMediaType';

import { MEDIA_STATUS } from '@/lib/routes/apiEndpoints';

type GetUploadedMediaType = {
    media_id: string;
    cancelToken?: AbortController;
};
export async function getUploadedMedia({
    media_id,
    cancelToken
}: GetUploadedMediaType): Promise<UploadedMediaType> {
    return new Promise((resolve, reject) => {
        async function getImage() {
            try {
                const uploadedMedia = await get<{ data: UploadedMediaType }>(
                    `${MEDIA_STATUS}/${media_id}`,
                    undefined,
                    { signal: cancelToken?.signal }
                );

                if (!uploadedMedia) {
                    return;
                }

                if (uploadedMedia.data.status === 'failed') {
                    return reject(new Error('errors:error_occured_submit_data'));
                }

                if (uploadedMedia.data.status === 'finished') {
                    return resolve(uploadedMedia.data);
                }

                return setTimeout(() => getImage(), 1500);
            } catch (error) {
                reject(new Error(`errors:error_occured_submit_data: ${error}`));
            }
        }
        getImage();
    });
}
